export default __webpack_public_path__ + "media/pro/pay_with_apple-3ccd8f60.svg";